
   import {defineComponent, h, nextTick, reactive, defineAsyncComponent} from 'vue'
   import {useRoute, useRouter} from "vue-router";
   import {useStore} from '@/store';
   import { Toast } from 'scvant';
//    import configData from './configData.js';
   import {GetReportFromJSON, GetReportFromServe, GetVerifyEffectiveReport, GetExpireReportUrl} from '@/service'
   const promiseFrame = defineAsyncComponent(() => import('./promiseFrame/index.vue'));
   const batteryFrame = defineAsyncComponent(() => import('./batteryFrame/index.vue'));
   interface State {
       reportData: object;
       renderComponent: string;
       lang: any;
   }
   export default defineComponent({
       name: "homePage",
       components: {
        promiseFrame,
        batteryFrame
       },
       setup() {
           let state: State = reactive({
               reportData: {},
               renderComponent: '',
               lang: ''
           })
        //    state.reportData = configData;
           document.title= "实车检测评估报告";
           const {query} = useRoute();
           const router = useRouter();
           const {reportCode, templateCode, reportVersion, targetPage, regenerate, originTemplateCode, lang} = query;
           state.lang = lang;
           let store = useStore()
           let queryCopy = JSON.parse(JSON.stringify(query));
           console.log(lang);
        //    store.dispatch('saveReportData', configData.data);
           
           // 预加载报告组件chunk，与API请求并行
           import('./promiseFrame/index.vue');
           import('./batteryFrame/index.vue');

           // 先尝试json文件
           Toast.loading({
               duration: 0,
               forbidClick: true,
               message: '加载中...',
           });
           // 替换图片地址函数
            function replaceImageUrl(str) {
                if (typeof str === 'string') {
                    // 将所有"img.souche.com"替换为"img-car-model.souche.com"
                    return str.replace(/img\.souche\.com/g, 'img-car-model.souche.com');
                }
                return str;
            }
            function setReportData (res){
                // res = mockData;
                state.reportData = res;
                // 替换图片地址  从源数据中替换，避免影响其他地方使用
                // 遍历componentList，找到code为'summary'的组件, 然后在其configItems中找到code为'brandLogo'的配置项，修改其value值
                // 查找componentList中code为'summary'的组件
                const summaryComponent = res.componentList.find((item: any) => item.code === 'summary');
                if (summaryComponent && summaryComponent.configItems) {
                    // 在configItems中查找code为'brandLogo'的配置项
                    const brandLogoConfig = summaryComponent.configItems.find((item: any) => item.code === 'brandLogo');
                    if (brandLogoConfig) {
                        // 修改brandLogo的值
                        brandLogoConfig.value = replaceImageUrl(brandLogoConfig.value);
                    }
                }
                store.dispatch('saveReportData', res);
                if (res.baseFrame.indexOf('romiseFrame')>0){
                    state.renderComponent = 'promiseFrame';
                } else {
                    state.renderComponent = res.baseFrame;
                }
                Toast.clear();
                nextTick(() => {
                    window.scrollTo(0, store.state.pageScrollTop)
                    store.dispatch('savePageScrollTop', 0);
                });
                let targetPage = sessionStorage.getItem('targetPage');
                sessionStorage.removeItem('targetPage');
                if (targetPage === 'photo_mark') {
                    let queryCopy = JSON.parse(JSON.stringify(query));
                    delete(queryCopy.targetPage);
                    // router.replace({
                    //     path: `/${state.renderComponent}`,
                    //     // query: queryCopy
                    // })
                    router.push({
                        path:`/${state.renderComponent}PhotoList`,
                        query: {
                            photoCode: res.markPhotoList[0].photoIdStr,
                            group: 'mark',
                            templateCode: templateCode
                        }
                    })
                }
           }
           GetReportFromJSON({reportCode, reportVersion, templateCode, lang}).then((res: any) => {
                setReportData(res.data);
           }).catch((err) => {
               if (err.message.indexOf('404')) {
                   // json文件404了请求直连接口
                   GetReportFromServe({reportCode, templateCode, reportVersion, regenerate, originTemplateCode, lang}).then((res: any) => {
                        setReportData(res);
                   }).catch((err) => {
                        setReportData(err);
                       console.error(err)
                   })
               } else {
                   console.error(err)
               }
           })
        //    setReportData(1);
           return {
               state,
               store
           }
       },
       beforeRouteEnter(to, from, next) {
            // const {reportCode, templateCode} = to.query;
            const {reportCode, reportVersion, templateCode, targetPage} = to.query;
            let time = 0;
            if (reportCode && typeof reportCode === 'string') {
                time = Number(reportCode.substring(2));
            }

            function getExpireReport() {
                if (!templateCode) {
                    to.query.templateCode = 'no_cert_report';
                }
                if(`${reportCode}`.indexOf('DE') > -1 && !to.query.lang) {
                    let url = '';
                    GetExpireReportUrl({reportCode, templateCode}).then((res: any) => {
                        url = res;
                        if (url) {
                            window.location.href = url;
                        } else {
                            next();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            
            function jump() {
                if (!templateCode) {
                    to.query.templateCode = 'no_cert_report';
                }
                if(`${reportCode}`.indexOf('DE') > -1 ) {
                    let isClose = true;
                    GetVerifyEffectiveReport({reportCode}).then((res: any) => {
                        isClose = res;
                        if (!isClose) {
                            next({
                                path: '/deffectiveReport',
                                query: {
                                    lang: to.query.lang
                                }
                            })
                        } else {
                            getExpireReport();
                        }
                    }).catch(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
            jump();
        }
   });
   